module.exports = __webpack_public_path__ + "img/pdf-icon-square.7fa8d6fa.svg";